module.exports = __webpack_public_path__ + "static/media/Small multiple violations of the 3.ad2a4e2a.png";